var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvoid = function SvgAvoid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    fill: "none",
    style: {
      marginRight: 4
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#avoid_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    x: 8,
    y: 6,
    fill: "#F65050",
    rx: 3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.167 20a5.833 5.833 0 1 0 11.666 0 5.833 5.833 0 0 0-11.666 0ZM22 12.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm-3.09 4.41a.834.834 0 0 1 1.18 0L22 18.823l1.91-1.911a.834.834 0 0 1 1.18 1.178L23.177 20l1.911 1.91a.834.834 0 0 1-1.178 1.18L22 21.177l-1.91 1.911a.834.834 0 0 1-1.18-1.178L20.823 20l-1.911-1.91a.834.834 0 0 1 0-1.18Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "avoid_svg__a",
    width: 37,
    height: 37,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_832_69652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_832_69652",
    result: "shape"
  })))));
};
export default SvgAvoid;